import React from "react";
import HeadingText from "./Heading";
import SubheadingText from "./Subheading";
import ParagraphText from "./Paragraph";
import SplitText from "./Split-Text";
import GalleryHorizontal from "./Gallery-Horizontal";
import GalleryStacked from "./Gallery-Stacked";
import HightlightText from "./Hightlight";
import { Wrapper, Break } from "../styles/components/Global/Global";
import { Lotus } from "./Lotus-Objects";

const SectionLight = () => {
  const section = "light";
  const gallery = Lotus.galleries.find(gallery => gallery.name === section);

  return (
    <Wrapper className={`scene-switch ${section}`}>
      <Wrapper $margin>
        <SplitText text="The game was well-received for its fast-paced gameplay, smooth controls, and is remembered by its fans for its groundbreaking use of vivid colors and exotic racing locales. In addition to its stunning visuals, the game was also renowned for its thumping soundtrack. Composed by Barry Leitch, players were propelled by upbeat and energetic electronic tunes that perfectly complement the fast-paced racing gameplay." />
        <Break $size="small" />
        <ParagraphText
          text="The music dynamically responds to the player's actions, intensifying as the race speeds up, creating an immersive and adrenaline-pumping experience."
          width="xlarge"
          align="flex-start"
          size="large"
          textAlign="left"
        />
        <ParagraphText
          text="This synchronization between the music and gameplay contributed to the game's cult following. Given the pure serendipity of the brand that gave him so much inspiration as a child, Ksawery paid homage to the game that served as a core inspiration for what he built. "
          width="small"
          textAlign="left"
        />
      </Wrapper>
      <Break $size="small" />
      <GalleryHorizontal gallery={gallery} />
      <Wrapper $margin>
        <HeadingText text="Light Sparkle Thunder" />
        <Break $size="small" $desktop />
        <HightlightText align="flex-end" />
        <Break $size="small" />
        <SubheadingText
          text="“I remember the scene when the car goes to the future for the very first time. There are so many lights, sparkles, thunder, and lightning bolts all around it as it shoots into the future. I thought these would be the perfect visual motifs for the installation, and would evoke the image of a car that really could just shoot itself into the future.” "
          width="small"
          textAlign="left"
        />
      </Wrapper>
      <GalleryStacked />
    </Wrapper>
  );
};

export default SectionLight;
